// extracted by mini-css-extract-plugin
export var activityContainer = "_n7-0";
export var typingIndicatorContainer = "_n7-1";
export var typingIndicatorDot = "_n7-2";
export var wave = "_n7-3";